var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGraphicActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24V8.00002H12V24H10ZM15.5 29.3334V2.66669H17.5V29.3334H15.5ZM4.5 18.6667V13.3334H6.5V18.6667H4.5ZM21 24V8.00002H23V24H21ZM26.5 18.6667V13.3334H28.5V18.6667H26.5Z",
    fill: "#594AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphicActive);
export default __webpack_public_path__ + "static/media/icon-graphic-active.be967c407c110b7c1167932fa43346d7.svg";
export { ForwardRef as ReactComponent };